module.exports = __webpack_public_path__ + "images/history-cat-3-6c9ee1122679ca3b1228998df509998f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/history-cat-3.png
 ** module id = 390
 ** module chunks = 0
 **/